import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import classnames from 'classnames';
import { toastr } from 'react-redux-toastr';
import { changeUserPassword } from '../../../action/ClientActions';
import CustomButton from '../../CustomButton';
import GreyHeader from '../../../component/dump/menuComponents/GreyHeader';
import { passwordValidation } from '../../helpers/helperAccount';

const ChangePasswordContainer = (props) => {
    const navigate = useNavigate();

    const [data, setData] = useState({
        new_password: '',
        new_password_confirm: ''
    });
    const [errMessage, setErrMessage] = useState({
        new_password: '',
        new_password_confirm: ''
    });
    const [toggle_password, setToggle_password] = useState(true);
    const [toggle_password_confirm, setToggle_password_confirm] = useState(true);

    const togglePassword = () => {
        setToggle_password(!toggle_password);
    }
    const togglePassword2 = () => {
        setToggle_password_confirm(!toggle_password_confirm);
    }

    const handleInputChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        let dataUpdate = data;
        dataUpdate[name] = value;
        setData(dataUpdate);
    }

    const checkForm = (data, e) => {
        let error = false;
        let errMessageUpdate = errMessage;

        for (let i in data) {
            if (data[i] == '') {
                error = true;
                errMessageUpdate[i] = 'Enter your password!';
            }
            else if (errMessageUpdate[i]) {
                errMessageUpdate[i] = null;
            }
        }

        if (!errMessageUpdate.new_password) {
            const validation = passwordValidation(data.new_password)
            if (!validation.result) {
                error = true;
                errMessageUpdate.new_password = validation.error;
            }
            else if (data.new_password !== data.new_password_confirm) {
                error = true;
                errMessageUpdate.new_password = 'Passwords do not match';
            }
        }

        if (!errMessageUpdate.new_password_confirm) {
            if (data.new_password !== data.new_password_confirm) {
                error = true;
                errMessageUpdate.new_password_confirm = 'Passwords do not match';
            }
        }
        setErrMessage(errMessageUpdate)
        return error;
    }

    const sendForm = (e) => {
        e.preventDefault();
        let dataUpdate = {
            user_email: props.location.state.user.email,
            new_password: data.new_password,
            new_password_confirm: data.new_password_confirm
        };

        const error = checkForm(dataUpdate, e);
        if (!error) {
            props.toggleLoader(true);
            changeUserPassword(dataUpdate)
                .then(res => {
                    props.toggleLoader(false);
                    navigate('/manageusers');
                    toastr.success('', 'Successfully changed password');
                })
                .catch(error => {
                    props.toggleLoader(false);
                    console.log('!ChangePasswordContainer sendForm error', error);
                    toastr.error("There was an issue changing the user's password. Please try again later.");
                });
        }
    }

    const { new_password, new_password_confirm } = errMessage;
    const user_email = props.location.state.user.email;

    return (
        <div>
            <GreyHeader title="Change Password" subtitle={user_email} />

            <main className='change-password main-content-block'>
                <h3 className="category-title text-center">Change Password</h3>
                <form onSubmit={sendForm}>
                    <section>
                        <div className={classnames('form-group fa-custom has-feedback', { 'has-error': new_password })}>
                            <label className="control-label">New Password:</label>
                            <div style={{ display: 'flex', flexDirection: 'row', padding: 0 }}>
                                <input type={toggle_password ? "password" : "text"} name="new_password" className="vehicle-search" data-toggle="new_password" onChange={handleInputChange} />
                                <span className="fa fa-eye form-control-feedback" onClick={togglePassword}></span>
                            </div>
                            {new_password && <span className="help-block">{new_password}</span>}
                        </div>
                    </section>

                    <section className={classnames({ 'has-error': new_password_confirm })}>
                        <div className={'form-group fa-custom has-feedback'}>
                            <label className="control-label">Confirm New Password:</label>
                            <div style={{ display: 'flex', flexDirection: 'row', padding: 0 }}>
                                <input type={toggle_password_confirm ? "password" : "text"} name="new_password_confirm" className="vehicle-search" onChange={handleInputChange} />
                                <span className="fa fa-eye form-control-feedback" name="new_password_confirm" onClick={togglePassword2}></span>
                            </div>
                            {new_password_confirm && <span className="help-block">{new_password_confirm}</span>}
                        </div>
                    </section>

                    <section className='text-center'>
                        <CustomButton onClick={sendForm} variant="secondary" size='lg'>Change Password</CustomButton>
                    </section>

                </form>
            </main>
        </div>
    );
}

export default connect(
    null,
    dispatch => ({
        toggleLoader: (show) => {
            dispatch({ type: 'TOGGLE_LOADER', payload: show });
        }
    })
)(ChangePasswordContainer);
